import { UsuarioService } from '../../services/usuario.service';
import { ClienteService } from '../../services/cliente.service';
import { UsuarioViewModel, NuevoUsuarioViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { Router } from '@angular/router';
var EditarUsuarioComponent = /** @class */ (function () {
    function EditarUsuarioComponent(usuarioService, clienteService, router) {
        this.usuarioService = usuarioService;
        this.clienteService = clienteService;
        this.router = router;
        this.tags = [];
        this.clientes = [];
        this.usuario = new UsuarioViewModel();
        this.usuarioPassword = new NuevoUsuarioViewModel();
        this.checkRol = [];
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = new Array();
    }
    EditarUsuarioComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
        this.usuario = this.usuarioService.getUsuario();
        if (!this.usuario) {
            this.usuario = new UsuarioViewModel();
            this.router.navigate(['dashboard/usuarios']);
            return;
        }
        this.tags = this.usuario.clientes;
        for (var _i = 0, _a = this.usuario.roles; _i < _a.length; _i++) {
            var r = _a[_i];
            this.checkRol[r.id] = true;
        }
        this.roles = this.usuarioService.obtenerRoles();
    };
    EditarUsuarioComponent.prototype.filtrar = function (event) {
        var _this = this;
        if (event.query.length > 3) {
            return this.clienteService.listado(0, 10, event.query).subscribe(function (response) {
                _this.clientes = response.clientes;
            });
        }
    };
    EditarUsuarioComponent.prototype.customTrackBy = function (index, rol) {
        return rol.id;
    };
    EditarUsuarioComponent.prototype.rolSeleccionado = function (event, rol) {
        if (event.target.checked) {
            this.usuario.roles.push(rol);
        }
        else {
            this.usuario.roles = this.usuario.roles.filter(function (r) { return r.id != rol.id; });
        }
    };
    EditarUsuarioComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.usuario.clientes = this.tags;
        this.usuarioService.modificar(this.usuario)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Modificar usuario";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El usuario se ha modificado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El usuario no se ha podido modificar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Modificar usuario";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El usuario no se ha podido modificar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    EditarUsuarioComponent.prototype.onSubmitPassword = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.usuarioService.actualizarPassword(this.usuario.id, this.usuarioPassword.password)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar contraseña usuario";
            if (result.status == 201) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Los datos se han actualizado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar contraseña usuario";
            _this.alert.mensaje = "Los datos se han actualizado correctamente";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    EditarUsuarioComponent.prototype.volver = function () {
        this.router.navigate(['dashboard/usuarios']);
    };
    EditarUsuarioComponent.ctorParameters = function () { return [{ type: UsuarioService }, { type: ClienteService }, { type: Router }]; };
    return EditarUsuarioComponent;
}());
export { EditarUsuarioComponent };
//# sourceMappingURL=editar-usuario.component.js.map


// WEBPACK FOOTER //
// editar-usuario.component.js